import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConfirmModal } from 'corso-admin-ui';
import api from '~/api';
import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export default function RestoreWarrantyClaim({
  show,
  onClose,
  claimId,
}: {
  claimId: number;
  show: boolean;
  onClose: () => void;
}) {
  const storeId = useStoreId();

  const queryClient = useQueryClient();
  const claim = useClaim();

  const { mutate: reopenClaim, isPending } = useMutation({
    mutationKey: [claimId],
    mutationFn: () => api.store(storeId).claim(`${claimId}`).reopen(),
    onSuccess: () =>
      Promise.all([
        claim.refetch(),
        queryClient.invalidateQueries({
          queryKey: ['claims'],
        }),
      ]),
  });

  return (
    <ConfirmModal
      variant="primary"
      title="Restore Canceled Claim"
      prompt="Restored claims will be set to Ready For Review, any finalized or denied line items will not be restored, and are considered final."
      confirmText="Restore"
      cancelText="Cancel"
      show={show}
      loading={isPending}
      onConfirm={() => {
        reopenClaim();
        onClose();
      }}
      onCancel={onClose}
    />
  );
}
